const Loader = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex-center-center z-50  bg-main-bg dark:bg-main-dark">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
